import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { planitemiconData } from "variables/MBM/lists/geb";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import moment from "moment";
import { plan2dItemText } from "variables/MBM/geb";
import LinkIcon from '@mui/icons-material/Link';


const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#ffffff',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 250,
        border: '1px solid #dadde9',
    },
}));

const getIcon = (icon) => {
    let iconret = QuestionMarkIcon;
    iconret = planitemiconData.find((item) => item.id === icon)?.icon || QuestionMarkIcon;
    return iconret;
}

const useStyles = makeStyles((theme) => ({
    planicondiv: {
        display: 'block',
        position: 'absolute',
        cursor: 'pointer',
        background: '#ffffffd6',
        borderRadius: 10,
    },
    smallplanicondiv: {
        minWidth: '24px',
    },
    mediumplanicondiv: {
        minWidth: '36px',
    },
    bigplanicondiv: {
        minWidth: '48px',
    },
    planicon: {
        padding: '3px',
        cursor: 'pointer',
    },
    planicontext: {
        padding: '0 5px 0 5px;',
        marginTop: '-5px',
        cursor: 'pointer',
        textAlign: 'center',
    },
    plantitletext: {
        padding: '0 5px 0 5px;',
        marginTop: '-5px',
        marginBottom: '5px',
        cursor: 'pointer',
    },
    plantitletextnoicon: {
        padding: '0 5px 0 5px;',
        marginTop: '0px',
        marginBottom: '5px',
        cursor: 'pointer',
    },
    titleparagraph: {
        marginBottom: '0px',
    },
    smallicon: {
        fontSize: '24px !important',
        marginLeft: 'calc(50% - 12px)',
    },
    mediumicon: {
        fontSize: '36px !important',
        marginLeft: 'calc(50% - 18px)',
    },
    bigicon: {
        fontSize: '48px !important',
        marginLeft: 'calc(50% - 24px)',
    },
    nocolor: {
        boxShadow: "0px 0px 4px #282b28",
    },
    greycolor: {
        boxShadow: "0px 0px 10px 2px #9798A0",
    },
    orangecolor: {
        boxShadow: "0px 0px 10px 2px #FF763A",
    },
    redcolor: {
        boxShadow: "0px 0px 10px 4px #C53F3F",
    },
    greencolor: {
        boxShadow: "0px 0px 4px #91C73C",
    },
    planicongreen: {
        display: 'block',
        position: 'absolute',
        cursor: 'pointer',
        color: "#91C73C",
        background: '#ffffffd6',
        borderRadius: 10,
    },
    data: {
        display: 'block',
        position: 'absolute',
        cursor: 'pointer',
        textAlign: 'center',
        borderRadius: 4,
        padding: "0 5px 0 5px",
        fontSize: "14px",
        fontWeight: 600,
        fontFamily: '"Source Sans Pro", sans-serif',
    },
    tooltiphtml: {
        fontSize: "13px",
        fontWeight: 400,
        fontFamily: '"Source Sans Pro", sans-serif',
    },
    tooltiphtmlheader: {
        textAlign: "center",
        fontSize: "13px",
        fontWeight: 600,
        fontFamily: '"Source Sans Pro", sans-serif',
    },
    smalltext: {
        fontSize: "12px",
    },
    mediumtext: {
        fontSize: "14px",
    },
    bigtext: {
        fontSize: "16px",
    },
    nocolortext: {
        background: '#ffffffd6',
        color: "rgba(0, 0, 0, 0.87)",
    },
    greentext: {
        background: '#91C73Cd6',
        color: "rgba(0, 0, 0, 0.87)",
    },
    bluetext: {
        background: '#3E8FC6d6',
        color: "rgba(0, 0, 0, 0.87)",
    },
    yellowtext: {
        background: '#D6D22Fd6',
        color: "rgba(0, 0, 0, 0.87)",
    },
    orangetext: {
        background: '#FF763Ad6',
        color: "rgba(0, 0, 0, 0.87)",
    },
    redtext: {
        background: '#C53F3Fd6',
        color: "rgba(255, 255, 255, 0.87)",
    },
    purpletext: {
        background: '#6B3CC8d6',
        color: "rgba(255, 255, 255, 0.87)",
    },
    link: {
        display: "flex",
        alignItems: "center",
        position: 'absolute',
        cursor: 'pointer',
        borderRadius: 4,
        padding: "0 5px 0 5px",
        fontSize: "12px",
        fontWeight: 600,
        fontFamily: '"Source Sans Pro", sans-serif',
    },
    linkicon: {
        fontSize: "17px !important",
    }
}));

const useStyles2 = makeStyles((theme) => ({
    planicondiv: {
        display: 'block',
        position: 'absolute',
        cursor: 'pointer',
        background: '#ffffffd6',
        borderRadius: 5,
    },
    smallplanicondiv: {
        minWidth: '12px',
    },
    mediumplanicondiv: {
        minWidth: '18px',
    },
    bigplanicondiv: {
        minWidth: '24px',
    },
    planicon: {
        padding: '1.5px',
        cursor: 'pointer',
    },
    planicontext: {
        padding: '0 2.5px 0 2.5px;',
        marginTop: '-2.5px',
        cursor: 'pointer',
        textAlign: 'center',
    },
    plantitletext: {
        padding: '0 2.5px 0 2.5px;',
        marginTop: '-2.5px',
        marginBottom: '5px',
        cursor: 'pointer',
    },
    plantitletextnoicon: {
        padding: '0 2.5px 0 2.5px;',
        marginTop: '0px',
        marginBottom: '2.5px',
        cursor: 'pointer',
    },
    titleparagraph: {
        marginBottom: '0px',
        lineHeight: '0.75em',
    },
    smallicon: {
        fontSize: '12px !important',
        marginLeft: 'calc(50% - 6px)',
    },
    mediumicon: {
        fontSize: '18px !important',
        marginLeft: 'calc(50% - 9px)',
    },
    bigicon: {
        fontSize: '24px !important',
        marginLeft: 'calc(50% - 12px)',
    },
    nocolor: {
        boxShadow: "0px 0px 2px #282b28",
    },
    greycolor: {
        boxShadow: "0px 0px 5px 1px #9798A0",
    },
    orangecolor: {
        boxShadow: "0px 0px 5px 1px #FF763A",
    },
    redcolor: {
        boxShadow: "0px 0px 5px 1px #C53F3F",
    },
    greencolor: {
        boxShadow: "0px 0px 2px #91C73C",
    },
    planicongreen: {
        display: 'block',
        position: 'absolute',
        cursor: 'pointer',
        color: "#91C73C",
        background: '#ffffffd6',
        borderRadius: 5,
    },
    data: {
        display: 'block',
        position: 'absolute',
        cursor: 'pointer',
        textAlign: 'center',
        borderRadius: 2,
        padding: "0 2.5px 0 2.5px",
        fontSize: "7px",
        fontWeight: 600,
        fontFamily: '"Source Sans Pro", sans-serif',
    },
    tooltiphtml: {
        fontSize: "13px",
        fontWeight: 400,
        fontFamily: '"Source Sans Pro", sans-serif',
    },
    tooltiphtmlheader: {
        textAlign: "center",
        fontSize: "13px",
        fontWeight: 600,
        fontFamily: '"Source Sans Pro", sans-serif',
    },
    smalltext: {
        fontSize: "6px",
    },
    mediumtext: {
        fontSize: "7px",
    },
    bigtext: {
        fontSize: "8px",
    },
    nocolortext: {
        background: '#ffffffd6',
        color: "rgba(0, 0, 0, 0.87)",
    },
    greentext: {
        background: '#91C73Cd6',
        color: "rgba(0, 0, 0, 0.87)",
    },
    bluetext: {
        background: '#3E8FC6d6',
        color: "rgba(0, 0, 0, 0.87)",
    },
    yellowtext: {
        background: '#D6D22Fd6',
        color: "rgba(0, 0, 0, 0.87)",
    },
    orangetext: {
        background: '#FF763Ad6',
        color: "rgba(0, 0, 0, 0.87)",
    },
    redtext: {
        background: '#C53F3Fd6',
        color: "rgba(255, 255, 255, 0.87)",
    },
    purpletext: {
        background: '#6B3CC8d6',
        color: "rgba(255, 255, 255, 0.87)",
    },
    link: {
        display: "flex",
        alignItems: "center",
        position: 'absolute',
        cursor: 'pointer',
        borderRadius: 2,
        padding: "0 2.5px 0 2.5px",
        fontSize: "6px",
        fontWeight: 600,
        fontFamily: '"Source Sans Pro", sans-serif',
    },
    linkicon: {
        fontSize: "8.5px !important",
    }
}));

const getTextColorClass = (item, val, classes) => {
    let color = "nocolor";
    let colorclass = classes.nocolortext;
    if (val && val.status !== 'nodata') {
        if (item.parameters?.lowvalstep !== undefined && item.parameters?.lowvalstep !== "" && Number(val.value) <= Number(item.parameters.lowvalstep))
            color = item.parameters?.lowvalcolor || "nocolor";
        else if (item.parameters?.highvalstep !== undefined && item.parameters?.highvalstep !== "" && Number(val.value) >= Number(item.parameters.highvalstep))
            color = item.parameters?.highvalcolor || "nocolor";
        else
            color = item.parameters?.defaultvalcolor || "nocolor";
        if (color === 'nocolor')
            colorclass = classes.nocolortext;
        else if (color === 'green')
            colorclass = classes.greentext;
        else if (color === 'blue')
            colorclass = classes.bluetext;
        else if (color === 'orange')
            colorclass = classes.orangetext;
        else if (color === 'red')
            colorclass = classes.redtext;
        else if (color === 'yellow')
            colorclass = classes.yellowtext;
        else if (color === 'purple')
            colorclass = classes.purpletext;
    }
    return colorclass;
}

export function Plan2dEquipment(props) {
    
    const { onClick, item, avobboxs, lorawanboxs, iots, equipments, planrawdata, plan1ddata, plan1hdata, 
        datatime, points, plan2dfilters, onlynames, currentZoomState } = props;
   // const classes = currentZoomState.scale === 2 ? useStyles2() : useStyles();
    const classes = useStyles();
    // console.log(currentZoomState);
    let PlanIcon = getIcon(item.parameters.icon);
    let sizeclass = item.parameters.iconsize === 'big' ? classes.bigicon : item.parameters.iconsize === 'average' ? classes.mediumicon : classes.smallicon;
    let textsizeclass = item.parameters.iconsize === 'big' ? classes.bigtext : item.parameters.iconsize === 'average' ? classes.mediumtext : classes.smalltext;
    let divsizeclass = item.parameters.iconsize === 'big' ? classes.bigplanicondiv : item.parameters.iconsize === 'average' ? classes.mediumplanicondiv : classes.smallplanicondiv;

    let colorclass = classes.nocolor;
    let connexiontime = "";
    let info1 = "";
    let info2 = "";
    let displayitem = true;
    let eq = equipments.find((b) => b.id == item.parameters.equipment);
    if (eq) {
        connexiontime = eq.lastconnection;
        if (plan2dfilters.length > 0) {
            if (!plan2dfilters.includes(eq.definition))
                displayitem = false;
        }
    }
    if (!connexiontime || !moment(connexiontime).isValid())
        colorclass = classes.greycolor;
    else if (moment(connexiontime) > moment().add(-1, 'h'))
        colorclass = classes.greencolor;
    else if (moment(connexiontime) > moment().add(-1, 'd'))
        colorclass = classes.orangecolor;
    else
        colorclass = classes.redcolor;

    let val;
    let point;
    if (item.parameters.value) {
        let cloneddatatime = datatime.clone();
        cloneddatatime = cloneddatatime.add(datatime.utcOffset(), 'm').unix() * 1000;
        point = points.find((pt) => pt.id == item.parameters.value);

        if (point) {
            if (item.parameters?.valueagg === 'raw')
                val = getRawData(point.id, cloneddatatime, planrawdata);
            else if (item.parameters?.valueagg === 'hour')
                val = get1hData(point.pointid, cloneddatatime, plan1hdata);
            else if (item.parameters?.valueagg === 'day')
                val = get1dData(point.pointid, cloneddatatime, plan1ddata);
        }
    }
    if (item.parameters.coef && val?.value) {
        val.value = val.value * Number(item.parameters.coef);
    }
    let title = item.parameters.name;
    title = title.split('\n').map(str => <p className={classes.titleparagraph}>{str}</p>);
    // var match = /\r|\n/.exec(title);
    // if (match) 
    // {
    //     title = title.split('\n').map(str => <p className={classes.titleparagraph}>{str}</p>);
    // }

    return (
        <>
            {
                displayitem ?
                    <>
                        <HtmlTooltip title={
                            <>
                                <div className={classes.tooltiphtmlheader}>{title}</div>
                                <div className={classes.tooltiphtml}>{connexiontime ? plan2dItemText.connexiontime + ' ' + moment(connexiontime).format("DD/MM/YYYY HH:mm") : plan2dItemText.noconnexiontime}</div>
                                {
                                    item.parameters.layer === 'iot' ?
                                        <>
                                            <div className={classes.tooltiphtml}>{plan2dItemText.linkpower + ' : ' + (info1 || 'N/A')}</div>
                                            <div className={classes.tooltiphtml}>{plan2dItemText.battery + ' : ' + (info2 || 'N/A')}</div>
                                        </>
                                        : <></>
                                }
                            </>
                        }
                        >
                            <div className={classes.planicondiv + ' ' + colorclass + ' ' + divsizeclass}
                                style={{ top: '' + item.top, left: '' + item.left }}
                                onClick={(event) => onClick(event, item)}>
                                <PlanIcon
                                    className={sizeclass + ' ' + classes.planicon}

                                    onClick={(event) => onClick(event, item)}
                                />
                                {
                                    (item.parameters.displayname || onlynames) ? <div className={textsizeclass + ' ' + classes.plantitletext}>
                                        {title}
                                    </div> : <></>
                                }
                                {
                                    (typeof val === 'undefined' || val === null || onlynames) ?
                                        <></>
                                        :
                                        <div className={textsizeclass + ' ' + classes.planicontext}>
                                            {
                                                //((val.status === 'nodata') ? '--- ' : 
                                                //new Intl.NumberFormat('fr-FR').format(val.value) + ' ') + item.parameters.unit
                                                ((!val || val.status === 'nodata') ? '--- ' :
                                                    (point.displayproperties?.overwritevalues && point.displayproperties?.overwritevalues["" + val.value]) ?
                                                        point.displayproperties.overwritevalues["" + val.value] :
                                                        isNaN(val.value) ? val.value : new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 }).format(val.value) + ' ') + item.parameters.unit

                                            }
                                        </div>
                                }
                                {
                                    info2 ? <div className={textsizeclass + ' ' + classes.planicontext}>
                                        {info2}
                                    </div> : <></>
                                }
                            </div>
                        </HtmlTooltip>
                    </> : <></>
            }
        </>
    );
}

export function Plan2dIot(props) {
    const classes = useStyles();
    const { onClick, item, avobboxs, lorawanboxs, iots, equipments, plan2dfilters, onlynames } = props;
    // console.log(item);
    let displayitem = true;
    let PlanIcon = getIcon(item.parameters.icon);
    let sizeclass = item.parameters.iconsize === 'big' ? classes.bigicon : item.parameters.iconsize === 'average' ? classes.mediumicon : classes.smallicon;
    let textsizeclass = item.parameters.iconsize === 'big' ? classes.bigtext : item.parameters.iconsize === 'average' ? classes.mediumtext : classes.smalltext;
    let divsizeclass = item.parameters.iconsize === 'big' ? classes.bigplanicondiv : item.parameters.iconsize === 'average' ? classes.mediumplanicondiv : classes.smallplanicondiv;
    let colorclass = classes.nocolor;
    let connexiontime = "";
    let info1 = "";
    let info2 = "";
    if (item.parameters.layer === 'lorawanbox') {
        let box = lorawanboxs.find((b) => b.id == item.parameters.lorawanbox);
        if (box)
            connexiontime = box.lastconnection;

    }
    else if (item.parameters.layer === 'avobbox') {
        let box = avobboxs.find((b) => b.id == item.parameters.avobbox);
        if (box)
            connexiontime = box.lastconnection;

    }
    else if (item.parameters.layer === 'iot') {
        let iot = iots.find((b) => b.id == item.parameters.iot);
        if (iot) {
            connexiontime = iot.status?.lastseenat;
            info1 = iot.status?.margin ? iot.status.margin + ' db' : '';
            info2 = iot.status?.externalpowersource === 'true' ? 'AC' : iot.status?.deviceStatusbatterylevel ? iot.status.deviceStatusbatterylevel + "%" : "";
            if (plan2dfilters.length > 0) {
                if (!plan2dfilters.includes(iot.definition))
                    displayitem = false;
            }
        }

    }
    if (!connexiontime || !moment(connexiontime).isValid())
        colorclass = classes.greycolor;
    else if (moment(connexiontime) > moment().add(-1, 'h'))
        colorclass = classes.greencolor;
    else if (moment(connexiontime) > moment().add(-1, 'd'))
        colorclass = classes.orangecolor;
    else
        colorclass = classes.redcolor;
    let title = item.parameters.name;
    title = title.split('\n').map(str => <p className={classes.titleparagraph}>{str}</p>);

    return (
        <>
            {
                displayitem ?
                    <>
                        <HtmlTooltip title={
                            <>
                                <div className={classes.tooltiphtmlheader}>{title}</div>
                                <div className={classes.tooltiphtml}>{connexiontime ? plan2dItemText.connexiontime + ' ' + moment(connexiontime).format("DD/MM/YYYY HH:mm") : plan2dItemText.noconnexiontime}</div>
                                <div className={classes.tooltiphtml}>{plan2dItemText.linkpower + ' : ' + (info1 || 'N/A')}</div>
                                <div className={classes.tooltiphtml}>{plan2dItemText.battery + ' : ' + (info2 || 'N/A')}</div>
                            </>
                        }
                        >
                            <div className={classes.planicondiv + ' ' + colorclass + ' ' + divsizeclass}
                                style={{ top: '' + item.top, left: '' + item.left }}
                                onClick={(event) => onClick(event, item)}>
                                <PlanIcon
                                    className={sizeclass + ' ' + classes.planicon}

                                    onClick={(event) => onClick(event, item)}
                                />
                                {
                                    (item.parameters.displayname || onlynames) ? <div className={textsizeclass + ' ' + classes.plantitletext}>
                                        {title}
                                    </div> : <></>
                                }
                                {
                                    info1 ? <div className={textsizeclass + ' ' + classes.planicontext}>
                                        {info1}
                                    </div> : <></>
                                }
                                {
                                    info2 ? <div className={textsizeclass + ' ' + classes.planicontext}>
                                        {info2}
                                    </div> : <></>
                                }
                            </div>
                        </HtmlTooltip>
                    </> :
                    <></>
            }
        </>

    );
}

const getRawData = (id, currentdatatime, planrawdata) => {
    let val;
    if (planrawdata[id]) {
        let mindatatime = currentdatatime - (60 * 60 * 1000);
        planrawdata[id].forEach((data) => {
            let datatime = data.date;
            //  console.log(datatime,data.value);
            if (datatime > mindatatime && datatime <= currentdatatime && (!val || val.date < datatime)) {
                val = { ...data, status: 'ok', datatime: moment(data.date) };
            }
            else if (datatime <= currentdatatime && (!val || val.date < datatime))
                val = { ...data, status: 'old', datatime: moment(data.date) };
        });
    }
    else {
        val = { status: 'nodata' };
    }
    return val;
}
const get1hData = (id, currentdatatime, plan1hdata) => {
    let val;
    if (plan1hdata[id]) {
        let mindatatime = currentdatatime - (6 * 60 * 60 * 1000);
        plan1hdata[id].forEach((data) => {
            if (data.date > mindatatime && data.date <= currentdatatime && (!val || val.date < data.date)) {
                val = { ...data, status: 'ok', datatime: moment(data.date) };
            }
            else if (data.date <= currentdatatime && (!val || val.date < data.date))
                val = { ...data, status: 'old', datatime: moment(data.date) };
        });
    }
    else {
        val = { status: 'nodata' };
    }

    return val;
}
const get1dData = (id, currentdatatime, plan1ddata) => {
    let val;
    if (plan1ddata[id]) {
        let mindatatime = currentdatatime - (24 * 60 * 60 * 1000);
        plan1ddata[id].forEach((data) => {
            if (data.date > mindatatime && data.date <= currentdatatime && (!val || val.date < data.date)) {
                val = { ...data, status: 'ok', datatime: moment(data.date) };
            }
            else if (data.date <= currentdatatime && (!val || val.date < data.date))
                val = { ...data, status: 'old', datatime: moment(data.date) };
        });
    }
    else {
        val = { status: 'nodata' };
    }

    return val;
}

export function Plan2dData(props) {
    const classes = useStyles();
    let displayitem = true;
    const { onClick, item, points, planrawdata, plan1ddata, plan1hdata, datatime, plan2dfilters, equipmentdata, fullpointdata, onlynames } = props;
    let cloneddatatime = datatime.clone();
    cloneddatatime = cloneddatatime.add(datatime.utcOffset(), 'm').unix() * 1000;
    let sizeclass = item.parameters.textsize === 'big' ? classes.bigtext : item.parameters.textsize === 'average' ? classes.mediumtext : classes.smalltext;
    let colorclass = classes.nocolor;
    let fullpoint = fullpointdata.find((pt) => pt.id == item.parameters.value);
    if (fullpoint) {
        if (plan2dfilters.length > 0) {
            if (fullpoint.equipment) {
                let eqtmp = equipmentdata.find((i) => i.id == fullpoint.equipment);
                if (eqtmp) {
                    if (!plan2dfilters.includes(fullpoint.definition + "_" + eqtmp.definition))
                        displayitem = false;
                }
            }
        }
    }
    let point = points.find((pt) => pt.id == item.parameters.value);
    // console.log(point);
    let val;
    if (point) {
        if (item.parameters?.valueagg === 'raw')
            val = getRawData(point.id, cloneddatatime, planrawdata);
        else if (item.parameters?.valueagg === 'hour')
            val = get1hData(point.pointid, cloneddatatime, plan1hdata);
        else if (item.parameters?.valueagg === 'day')
            val = get1dData(point.pointid, cloneddatatime, plan1ddata);
    }
    if (item.parameters.coef && val?.value) {
        val.value = val.value * Number(item.parameters.coef);
    }
    if (!val || val.status !== 'ok')
        colorclass = classes.orangecolor;
    let textcolorclass = getTextColorClass(item, val, classes);
    let title = item.parameters.name;
    title = title.split('\n').map(str => <p className={classes.titleparagraph}>{str}</p>);

    return (
        <>
            {
                displayitem ?
                    <>
                        <HtmlTooltip title={
                            <>
                                <div className={classes.tooltiphtmlheader}>{title}</div>
                                <div className={classes.tooltiphtml}>{(!val || val.status === 'nodata') ? plan2dItemText.nodata : plan2dItemText.datatime + ' ' + val.datatime.utc().format("DD/MM/YYYY HH:mm")}</div>
                            </>
                        }>
                            <div
                                className={classes.data + ' ' + sizeclass + ' ' + colorclass + ' ' + textcolorclass}
                                style={{ top: '' + item.top, left: '' + item.left }}
                                onClick={(event) => onClick(event, item)}
                            >
                                {
                                    (item.parameters.displayname || onlynames) ? <div className={sizeclass + ' ' + classes.plantitletextnoicon}>
                                        {title}
                                    </div> : <></>
                                }
                                {
                                    ((!val || val.status === 'nodata') ? '--- ' : onlynames ? '' :
                                        (point.displayproperties?.overwritevalues && point.displayproperties?.overwritevalues["" + val.value]) ?
                                            point.displayproperties.overwritevalues["" + val.value] :
                                            new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 }).format(val.value) + ' ') + item.parameters.unit
                                }

                            </div>
                        </HtmlTooltip>
                    </> : <></>
            }
        </>
    );
}

export function Plan2dLink(props) {
    const classes = useStyles();
    const { onClick, item, plans } = props;

    let textcolorclass = classes.nocolortext;
    let sizeclass = classes.smalltext;
    let colorclass = classes.nocolor;
    let planname = plans.find((p) => p.id === item.parameters.linkedplan)?.parameters?.name || plan2dItemText.nolinkto;
    return (
        <>
            <HtmlTooltip title={
                <>
                    <div className={classes.tooltiphtmlheader}>{plan2dItemText.linkto + ' ' + planname}</div>
                </>
            }>
                <div
                    className={classes.link + ' ' + sizeclass + ' ' + colorclass + ' ' + textcolorclass}
                    style={{ top: '' + item.top, left: '' + item.left }}
                    onClick={(event) => onClick(event, item)}
                >
                    <LinkIcon className={classes.linkicon}></LinkIcon>
                    {
                        ' ' + item.parameters.name
                    }

                </div>
            </HtmlTooltip>
        </>
    );
}